// app/frontend/controllers/telemetry_actions_controller.js
import { Controller } from "@hotwired/stimulus"
import * as Turbo from "@hotwired/turbo"

export default class extends Controller {
  static values = { configureUrl: String, reapplyUrl: String }

  async configure(e){ e?.preventDefault(); await this._post(this.configureUrlValue) }
  async reapply(e){ e?.preventDefault(); await this._post(this.reapplyUrlValue) }

  async _post(url){
    const res  = await fetch(url, { method: "POST",
                                    headers: { "X-CSRF-Token": this._csrf(), "Accept":"text/vnd.turbo-stream.html" } })
    const body = await res.text()
    if (res.headers.get("content-type")?.includes("turbo-stream")) Turbo.renderStreamMessage(body)
    if (!res.ok) console.error(body)
  }
  _csrf(){ return document.querySelector('meta[name="csrf-token"]').content }
}
